require('babel-polyfill');
require('./includes/matches-polyfill');
require('./includes/closest-polyfill');
const Tracker = require('../../global/js/modules/google-analytics');

//IE....
(function () {

    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


//includes (no modules)

//For now we're wrapping every include in a try/catch to prevent errors breaking everything

try {
    require('./includes/google-recapatcha-boot');
} catch (e) {
    console.error('Error loading font-awesome:', e);
}

try {
    require('./includes/font-awesome');
} catch (e) {
    console.error('Error loading font-awesome:', e);
}


try {
    require('./includes/google-analytics');
} catch (e) {
    console.error('Error loading google analytics:', e);
}


try {
    require('./includes/tab-groups');
}
catch (e) {
    console.error('Error loading tab groups', e);
}

try {
    require('./components/bootstrap');
} catch (e) {
    console.error('Error loading locations', e);
}

try {
    require('./includes/sections/booking/launchpad');
} catch (e) {
    console.error('Error loading booking/launchpad:', e);
}


try {
    require('./includes/accordion');
} catch (e) {
    console.error('Error loading accordion:', e);
}

try {
    require('./includes/sections/booking/_global');
} catch (e) {
    console.error('Error loading booking/_global:', e);
}

try {
    require('./includes/sections/booking/select-extras');
} catch (e) {
    console.error('Error loading booking/select-vehicle:', e);
}

try {
    require('./includes/sections/booking/select-vehicle');
} catch (e) {
    console.error('Error loading booking/select-vehicle:', e);
}

try {
    require('./includes/sections/booking/review');
} catch (e) {
    console.error('Error loading booking/review:', e);
}


try {
    require('./includes/sections/booking/thanks');
} catch (e) {
    console.error('Error loading booking/thanks:', e);
}


try {
    require('./includes/sections/my-account/bookings');
} catch (e) {
    console.error('Error loading my-account/bookings:', e);
}


try {
    require('./includes/sections/my-account/register');
} catch (e) {
    console.error('Error loading my-account/register:', e);
}


try {
    require('./includes/sections/my-account/my-details');
} catch (e) {
    console.error('Error loading my-account/my-details:', e);
}


try {
    require('./includes/dropdan');
} catch (e) {
    console.error('Error loading dropdan:', e);
}
try {
    require('./includes/footer');
} catch (e) {
    console.error('Error loading footer:', e);
}
try {
    require('./includes/google-maps');
} catch (e) {
    console.error('Error loading google maps:', e);
}
try {
    require('./includes/booking-launcher');
} catch (e) {
    console.error('Error loading forms:', e);
}
try {
    require('./includes/mobile-menu');
} catch (e) {
    console.error('Error loading mobile-menu:', e);
}
try {
    require('./includes/page-transitions');
} catch (e) {
    console.error('Error loading page-transitions:', e);
}
try {
    require('./includes/slider');
} catch (e) {
    console.error('Error loading slider:', e);
}
try {
    require('./includes/textarea-limits');
} catch (e) {
    console.error('Error loading textarea limits:', e);
}

try {
    require('./includes/sections/locations');
}
catch (e) {
    console.error('Error loading locations', e);
}

try {
    require('./includes/sections/location');
}
catch (e) {
    console.error('Error loading location', e);
}

try {
    require('./includes/bookings-notifier');
}
catch (e) {
    console.error('Error loading bookings notifier', e);
}

try {
    require('./includes/toggle-content');
}
catch (e) {
    console.error('Error loading toggle content behaviour', e);
}

try {
    require('./includes/operational-leasing');
}
catch (e) {
    console.error('Error loading operational leasing', e);
}

try {
    require('./includes/hover-tooltips');
}
catch (e) {
    console.error('Error loading hover tooltips', e);
}

document.addEventListener('DOMContentLoaded', () => {
    window['_Tracker'] = Tracker;
    document.querySelector('html').classList.add('js');

    const isIphone = navigator.userAgent.indexOf("iPhone") !== -1,
        isIpod = navigator.userAgent.indexOf("iPod") !== -1,
        isIpad = navigator.userAgent.indexOf("iPad") !== -1;

    if (isIpad || isIphone || isIpod) {
        document.querySelector('html').classList.add('ios');
    }


});
